import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const headers = (token) => ({ headers: { 'x-auth-token': token } });

export async function listCaseNotes({ token, clientId }) {
  const res = await axios.get(
    `${API_BASE_URL}/case-notes?clientId=${encodeURIComponent(clientId)}`,
    headers(token)
  );
  return res.data;
}

export async function createCaseNote({ token, clientId, title, body, tags, pinned, visibility }) {
  const res = await axios.post(
    `${API_BASE_URL}/case-notes`,
    { clientId, title, body, tags, pinned, visibility },
    headers(token)
  );
  return res.data;
}

export async function updateCaseNote({ token, noteId, title, body, tags, pinned, visibility }) {
  const payload = {};
  if (title     !== undefined) payload.title = title;
  if (body      !== undefined) payload.body = body;
  if (tags      !== undefined) payload.tags = tags;
  if (pinned    !== undefined) payload.pinned = pinned;
  if (visibility !== undefined) payload.visibility = visibility;
  const res = await axios.patch(
    `${API_BASE_URL}/case-notes/${noteId}`,
    payload,
    headers(token)
  );
  return res.data;
}

export async function deleteCaseNote({ token, noteId }) {
  const res = await axios.delete(
    `${API_BASE_URL}/case-notes/${noteId}`,
    headers(token)
  );
  return res.data;
}
